import React, {
  useState,
  useEffect,
} from 'react';
import { Popover } from 'react-tiny-popover';

import {
  WorkoutExercise,
} from '@gymcloud/core';

import {
  Icon,
  Tooltip,
} from 'web-components';

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

import * as S from './styled';

type Props = {
  readOnly?: boolean,
  exercise: WorkoutExercise,

  onAdd?: { (exerciseId: number): void },
  onSet?: { (exerciseId: number, alternativeId: number): void },
  onRemove?: { (exercise: any): void },
};

const Alternatives = ({
  exercise,
  readOnly = false,
  onAdd,
  onSet,
  onRemove,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [firstTooltipIsOpen, setFirstTooltipIsOpen] = useState(false);

  useEffect(() => {
    if (!readOnly && exercise.hasFirstAlternative) {
      setFirstTooltipIsOpen(true);
      const timer = setTimeout(() => {
        setFirstTooltipIsOpen(false);
      }, 3000);

      return () => {
        clearTimeout(timer);
      };
    }

    return () => { };
  }, [readOnly, exercise.hasFirstAlternative]);

  if (!exercise.alternatives.length) return null;

  const tooltipProps = firstTooltipIsOpen
    ? {
      body: 'Alternative exercise added. Click to edit.',
      isOpen: true,
    }
    : {
      body: exercise.alternatives.map(e => e.name).join(' '),
    };

  const trigger = (
    <Tooltip {...tooltipProps} positions={['top']}>
      <S.AlternativesTrigger>
        {exercise.alternatives.length}
      </S.AlternativesTrigger>
    </Tooltip>
  );

  if (readOnly) return trigger;

  return (
    <Popover
      isOpen={isOpen}
      positions={['bottom', 'right']}
      content={(
        <S.Dropdown>
          <Flex
            column
            padding="10px 20px 5px 20px"
            spacing={5}
          >
            <Text
              size="12px"
              color="#999999"
            >
              ALTERNATIVES
            </Text>
            <Flex
              align="center"
              spacing={5}
              clickable
              onClick={() => {
                setIsOpen(false);
                onAdd?.(exercise.id);
              }}
            >
              <S.PlusCircle />
              <Text
                color="primary"
              >
                ADD ALTERNATIVE
              </Text>
            </Flex>
          </Flex>
          {exercise.alternatives.map(e => (
            <S.Item
              key={e.id}
              onClick={() => {
                onSet?.(exercise.id, e.id);
                setIsOpen(false);
              }}
            >
              {e.name}
              <S.Remove
                type="button"
                onClick={(ev) => {
                  ev.stopPropagation();
                  onRemove?.(e);
                  setIsOpen(false);
                }}
              >
                <SVG.X className="danger-color" size={13} />
              </S.Remove>
            </S.Item>
          ))}
        </S.Dropdown>
      )}
      onClickOutside={() => setIsOpen(false)}
    >
      <Flex onClick={() => setIsOpen(!isOpen)}>
        {trigger}
      </Flex>
    </Popover>
  );
};

export default Alternatives;
